/* eslint camelcase: off, @typescript-eslint/naming-convention: off */
import { configure, localize, extend } from 'vee-validate'
import {
  required,
  max,
  numeric,
  min,
  min_value,
  max_value
} from 'vee-validate/dist/rules'
import { ro } from '@/lang/ro'

// Remove field names for now from our
// validation translation keys
const validationMessagesRo: any = Object.keys(ro.validation).reduce(
  (acc, x) => ({
    ...acc,
    [x]: (ro.validation as any)[x].replace(/\s*\{_field_\}/g, '')
  }),
  {}
)

// No message specified.
extend('required', { ...required, message: validationMessagesRo.required })
extend('max', { ...max, message: validationMessagesRo.max })
extend('numeric', { ...numeric, message: validationMessagesRo.numeric })
extend('min', { ...min, message: validationMessagesRo.min })
// For numeric inputs, prefer min_value/max_value so we validate numeric ranges, not string length.
extend('min_value', {
  ...min_value,
  message: validationMessagesRo.min_value
})
extend('max_value', {
  ...max_value,
  message: validationMessagesRo.max_value
})

// set messages for loaded validation
localize('ro', validationMessagesRo)

const config = {
  // se a default error message
  defaultMessage: ro.validation.default,
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  bails: false,
  skipOptional: true,
  mode: 'eager', // see: https://logaretm.github.io/vee-validate/guide/interaction-and-ux.html#interaction-modes
  useConstraintAttrs: true
}

// Sets the options.
configure(config)
